/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PartnerCallSessionProjection
 */
export interface PartnerCallSessionProjection {
    /**
     * 
     * @type {number}
     * @memberof PartnerCallSessionProjection
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof PartnerCallSessionProjection
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerCallSessionProjection
     */
    street: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerCallSessionProjection
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerCallSessionProjection
     */
    zip: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerCallSessionProjection
     */
    phone: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerCallSessionProjection
     */
    mobile: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerCallSessionProjection
     */
    currentStatus: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerCallSessionProjection
     */
    nafCode: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerCallSessionProjection
     */
    siret: string;
}

/**
 * Check if a given object implements the PartnerCallSessionProjection interface.
 */
export function instanceOfPartnerCallSessionProjection(value: object): value is PartnerCallSessionProjection {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('street' in value) || value['street'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('zip' in value) || value['zip'] === undefined) return false;
    if (!('phone' in value) || value['phone'] === undefined) return false;
    if (!('mobile' in value) || value['mobile'] === undefined) return false;
    if (!('currentStatus' in value) || value['currentStatus'] === undefined) return false;
    if (!('nafCode' in value) || value['nafCode'] === undefined) return false;
    if (!('siret' in value) || value['siret'] === undefined) return false;
    return true;
}

export function PartnerCallSessionProjectionFromJSON(json: any): PartnerCallSessionProjection {
    return PartnerCallSessionProjectionFromJSONTyped(json, false);
}

export function PartnerCallSessionProjectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartnerCallSessionProjection {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'street': json['street'],
        'city': json['city'],
        'zip': json['zip'],
        'phone': json['phone'],
        'mobile': json['mobile'],
        'currentStatus': json['current_status'],
        'nafCode': json['naf_code'],
        'siret': json['siret'],
    };
}

export function PartnerCallSessionProjectionToJSON(json: any): PartnerCallSessionProjection {
    return PartnerCallSessionProjectionToJSONTyped(json, false);
}

export function PartnerCallSessionProjectionToJSONTyped(value?: PartnerCallSessionProjection | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'street': value['street'],
        'city': value['city'],
        'zip': value['zip'],
        'phone': value['phone'],
        'mobile': value['mobile'],
        'current_status': value['currentStatus'],
        'naf_code': value['nafCode'],
        'siret': value['siret'],
    };
}

